import type { JSX } from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { useFinalCta } from './hooks/useFinalCta';

export function FinalCta(): JSX.Element {
	const { actions, data } = useFinalCta();

	return (
		<div className="bg-background-raised relative z-0 py-14">
			<div className="container">
				<div className="flex flex-col items-center justify-center gap-6 text-center">
					<Text as="h2" variant="heading" className="text-size-heading max-w-xl">
						Start your next campaign on Change.org
					</Text>
					<Text as="p" variant="body" size="large" className="text-size-body-xl hidden max-w-4xl md:block">
						Join nonprofits around the world using Change.org to reach more supporters, influence decision makers, and
						create real change.
					</Text>
					<Text as="p" variant="body" size="large" className="text-size-body-xl md:hidden">
						Join nonprofits around the world using Change.org to create real change.
					</Text>
					<div className="flex flex-col gap-4 md:flex-row">
						<Button
							as="a"
							href={data.primaryCtaUrl}
							variant="primary-strong"
							className="w-full md:w-auto"
							onClick={actions.onPrimaryCtaClick}
						>
							Start a petition
						</Button>
						<Button
							as="a"
							href={data.secondaryCtaUrl}
							variant="secondary-solid"
							className="w-full md:w-auto"
							onClick={actions.onSecondaryCtaClick}
						>
							Talk to our team
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
